import {mapState} from "vuex";
import Vue from "vue";
import {User} from "@/api/users";

function isUser(assigneeRef: string, u: User): boolean {
    if (assigneeRef !== null && isNaN(+assigneeRef)) {
        if (
            u.id &&
            u.username.toLowerCase().toString() ===
            assigneeRef.toLowerCase().toString()
        ) {
            return true;
        } else {
            return false;
        }
    } else if (assigneeRef !== null) {
        if (u.id && u.id.toString() === assigneeRef.toString()) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export default Vue.extend({
    computed: {
        ...mapState("user", ["users"]),
    },
    methods: {
        hasAvatarImage(assigneeRef: string): boolean {
            const user = this.users.find((u: User) => {
                return isUser(assigneeRef, u);
            });
            if (user) {
                return user.avatarSmall !== null;
            }
            return false;
        },
        getAvatarName(assigneeRef: string): string {
            const user = this.users.find((u: User) => {
                return isUser(assigneeRef, u);
            });
            if (user && user.username) {
                return user.username;
            }
            return "";
        },
        getAvatarImage(assigneeRef: string): string {
            const user = this.users.find((u: User) => {
                return isUser(assigneeRef, u);
            });
            if (user) {
                return user.avatarSmall;
            }
            return "";
        },
        getAvatarAbbreviation(assigneeRef: string): string {
            const user = this.users.find((u: User) => {
                return isUser(assigneeRef, u);
            });
            if (user) {
                return user.username.substr(0, 2);
            }
            if (!isNaN(+assigneeRef)) {
                return "?";
            }
            if (assigneeRef === 'Unbekannt') {
                return "?";
            }
            return assigneeRef;
        },
    },
});
